// src/mixins/toggleMixin.js
import { EventBus } from "@/EventBus";
export const toggleMixin = {
  data() {
    return {
      isExpanded: false,
      isopen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isExpanded = !this.isExpanded;
      this.isopen = !this.isopen;
    },
    toggleTheme() {
      EventBus.$emit("triggerToggleTheme");
    },
  },
};
